import React from "react"
import { Row, Col } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import InlightMediaLogo from "../Individuals/InlightMediaLogo"
import MessageFromModalButton from "../MessageFromModal/MessageFromModalButton"
import MessageFormModalButtonSchweitzer from "../MessageFromModal/MessageFormModalButtonSchweitzer"
import IdahoPowerLogo from '../IdahoPowerLogo'
import UnitedHeritageLogo from '../UnitedHeritageInsurance'
import AlbertsonsLogo from '../AlbertsonsLogo'
import CitizenCommunityBankLogo from '../CitizenCommunityBankLogo'
import FirstInterstateBankLogo from '../FirstInterstateBankLogo'

import GoldLevel from './GoldLevel'
import SilverLevel from './SilverLevel'
import BronzeLevel from './BronzeLevel'
import CopperLevel from './CopperLevel'
import BrassLevel from './BrassLevel'
import * as style from "../Supporters.module.css"
import IdahoCentralLogo from "../IdahoCentralCreditUnion";
import ConPaulosLogo from "../ConPaulosLogo"
import AgriBeefLogo from "../AgriBeefLogo"
import AlbertsonsFamilyLogo from "../AlbertsonsFamilyLogo"
import BattelleLogo from "../BattelleLogo"
import HeclaMiningCompanyLogo from "../HeclaLogo"
import SELLogo from "../SELLogo"
import DeltaDentalLogo from "../DeltaDentalLogo";
import SimplotLongLogo from "../SimplotLongLogo"
import AvistaLogo from "../AvistaLogo"
import BoiseCascadeLogo from "../BoiseCascadeLogo"
import IdahoForestGroupLogo from "../IdahoForestGroupLogo";

const PlatinumLevel = () => {
    const data = useStaticQuery(graphql`
    {
      nathanChristensen: file(relativePath: { eq: "Nathan-Christensen-CCB-President-Headshot.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nateJorgensen: file(relativePath: { eq: "NateJorgensen.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      conPaulosLogo: file(relativePath: { eq: "conPaulos.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      conPaulos: file(relativePath: { eq: "ConPaulos.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      brendaWorrel: file(relativePath: { eq: "Brenda-Worrell-2025.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      dennisJohnson: file(relativePath: { eq: "dennis_johnson.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lisaGrow: file(relativePath: { eq: "lisa_grow.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      johnColgrove: file(relativePath: { eq: "JohnColgrove.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      unitedHeritage: file(relativePath: { eq: "uh_web_logo_80-1.png" }) {
        childImageSharp {
          fluid(maxWidth: 100, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      toddGill: file(relativePath: { eq: "ToddGill.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      jeffNewgard: file(relativePath: { eq: "JeffNewgard.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lorrieAsker: file(relativePath: { eq: "LorrieAsker.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      robRebholtz: file(relativePath: { eq: "RobRebholtz.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      jkafLogo: file(relativePath: { eq: "jkaf.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      simplotLogoWhite: file(relativePath: { eq: "SimplotCompanyFoundationLogo_white.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      johnCWagner: file(relativePath: { eq: "JohnCWagner.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      rogerQuarles: file(relativePath: { eq: "RogerQuarles.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      phillipsBaker: file(relativePath: { eq: "PhillipsBaker.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      edumundSchweitzer: file(relativePath: { eq: "EdmundSchweitzer.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      daveWhitehead: file(relativePath: { eq: "DaveWhitehead.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      gregDonaca: file(relativePath: { eq: "GregDonaca.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      garrettLofto: file(relativePath: { eq: "GarrettLofto.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      scottSimplot: file(relativePath: { eq: "ScottSimplot.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      marcBrinkmeyer: file(relativePath: { eq: "MarcBrinkmeyer.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      bradStreet: file(relativePath: { eq: "BradStreet.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
        higman: file(relativePath: { eq: "J-Higham.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
        potatoCommissionLogo: file(relativePath: { eq: "idaho-potato-commission.png" }) {
        childImageSharp {
          fluid(maxWidth: 135, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
        L3HarrisLogo: file(relativePath: { eq: "L3Harris_logo_reg_rev_rgb.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
        L3HarrisLogoAlt: file(relativePath: { eq: "L3Harris_logo_reg_rgb.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
        ninoDiCosmo: file(relativePath: { eq: "nino-dicosmo-0619.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
         intermountainGasLogo: file(relativePath: { eq: "IGC-Logo-C-300dpi.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hartGilchrist: file(relativePath: { eq: "HartGilchrist-2024-headshot.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  

  return (
      <div className="tab-content">
        
        <h3 className="text-center my-4">We are very honored to have the following generous Corporate Donors</h3>
        <hr />
        <div className={style.stickyHeader} style={{ zIndex: 50 }}><h1 className="text-center">Platinum Level Corporate Donors - $50,000+</h1></div>
    <Row className={`${style.supportersRow} my-4`}>
      <Col md={2} className="text-center logo-col">
        <IdahoPowerLogo />
        <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
      </Col>
      <Col md={10}>
        <h2>Idaho Power</h2>
        <h4>Idaho Power, headquartered in vibrant and fast-growing Boise, Idaho, has been a locally operated energy company since 1916. The company’s goal to provide 100% clean energy by 2045 builds on its long history as a clean-energy leader that provides reliable service at affordable prices.</h4>
        <MessageFromModalButton 
        messagePerson="Lisa Grow"
        personTitle="CEO of Idaho Power"
        partnerUrl="https://www.idahopower.com"
        partner="Idaho Power"
        message="We are so proud to support the USS Idaho, those who will serve aboard this impressive and historic submarine, and their families."
        personPhoto={data.lisaGrow.childImageSharp.fluid}
        partnerLogo={<IdahoPowerLogo />}
      />
      </Col>
    </Row>
    <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
     <AlbertsonsLogo />
     <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Albertsons</h2>
      <h4>Locally great and nationally strong, Albertsons Companies (NYSE: ACI) is one of the largest food and drug retailers in the United States, operating stores across 34 states and the District of Columbia under 20 well-known banners. Albertsons Cos. is committed to helping people across the country live better lives by making a meaningful difference, neighborhood by neighborhood. In 2019 alone, along with the Albertsons Companies Foundation, the Company gave over $225 million in food and financial support. These efforts helped millions of people in the areas of hunger relief, education, cancer research and treatment, programs for people with disabilities and veterans outreach.</h4>
      <MessageFromModalButton 
        messagePerson="Brad Street"
        personTitle="Division President, Albertsons Companies Mountain West Division"
        partnerUrl="https://www.albertsons.com"
        partner="Albertsons"
        personPhoto={data.bradStreet.childImageSharp.fluid}
        message="Albertsons is honored to support the USS IDAHO, its crew and their families. Our Company has a long history of supporting the communities we serve, and want to recognize and highlight the military members committed to protecting our country."
        partnerLogo={<AlbertsonsLogo />}
      />
    </Col>
  </Row>
    <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <UnitedHeritageLogo />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>United Heritage Insurance</h2>
      <h4>United Heritage Insurance is a family of mutual companies that combines life, disability, vision, home and auto insurance. Our companies were founded over a century ago and continue to serve our communities and customers with financial strength and service excellence. We are here to help people and hundreds of employees and thousands of agents across the country strive to meet this vision every day.</h4>
      <MessageFromModalButton 
        messagePerson="Todd H. Gill"
        personTitle="President and CEO of United Heritage Insurance"
        partnerUrl="https://www.unitedheritage.com/index.php"
        partner="United Heritage Insurance"
        message="Supporting our military families is critical, knowing firsthand the sacrifice and commitment my father and brother-in-law made in their US Navy careers. We are proud supporters of our military, the US Navy, the USS Idaho, and especially the families of those serving on the USS Idaho."
        personPhoto={data.toddGill.childImageSharp.fluid}
        partnerLogo={<UnitedHeritageLogo />}
      />
    </Col>
  </Row>
  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <CitizenCommunityBankLogo />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Citizens Community Bank, Division of Glacier Bank</h2>
      <h4>At Citizens Community Bank, we are dedicated to serving our customers, enriching communities, and creating lasting relationships. We are more than just a bank, we are a "friend you can talk to."
      </h4>
      <MessageFromModalButton 
        messagePerson="Nathan Christensen"
        personTitle="President of Citizens Community Bank"
        partnerUrl="https://www.ccb-idaho.com/"
        partner="Citizens Community Bank, Division of Glacier Bank"
        message="At Citizens Community Bank, we pride ourselves in support​​ing the communities we serve across eastern Idaho. We are honored to be able to extend that support to the courageous men and women who will serve on the USS IDAHO. We thank you and your families for your service and sacrifices."
        personPhoto={data.nathanChristensen.childImageSharp.fluid}
        partnerLogo={<CitizenCommunityBankLogo />}
      />
    </Col>
  </Row>

  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <FirstInterstateBankLogo />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>First Interstate Bank</h2>
      <h4>For decades, First Interstate has been part of the fabric of many hard-working towns and cities. Our belief—that community banking means so much more than simply transactions and accounts—is rooted in an approach to service centered around you. <strong>First Interstate Bank—Built for you.</strong></h4>
      <MessageFromModalButton 
        messagePerson="Lorrie Asker"
        personTitle="Regional President First Interstate Bank"
        partnerUrl="https://www.firstinterstatebank.com"
        partner="First Interstate Bank"
        message="Honoring our heroes and acknowledging their sacrifice is critical to maintaining liberty. It is with great esteem and appreciation that we support the commissioning of the USS Idaho. We are especially pleased to see a portion of our support provide a scholarship fund for the children of the USS Idaho’s service men and women."
        personPhoto={data.lorrieAsker.childImageSharp.fluid}
        partnerLogo={<FirstInterstateBankLogo />}
      />
    </Col>
  </Row>

  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <ConPaulosLogo />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Con Paulos Chevrolet</h2>
      <h4>Home of the Warranty Forever</h4>
      {/* <h4>Our staff is totally committed to "Doing Business Your Way" because the true measure of our success are Satisfied Customers. We are trusted by the Magic Valley to provide excellent value and "World Class Service" and we are constantly searching for improved ways to serve "You" our customer.</h4> */}
      <MessageFromModalButton 
        messagePerson="Con Paulos"
        personTitle="Owner of Con Paulos Chevrolet"
        partnerUrl="https://www.conpaulos.com"
        partner="Con Paulos Chevrolet"
        message="Con Paulos Chevrolet is proud to support the efforts of the USS Idaho SSN 799 Commissioning Foundation"
        personPhoto={data.conPaulos.childImageSharp.fluid}
        partnerLogo={<ConPaulosLogo />}
      />
    </Col>
  </Row>

  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <IdahoCentralLogo fillcolor='#1c8900' />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Idaho Central Credit Union</h2>
      <h4>Idaho Central is the premier credit union in Idaho and offers full-service locations throughout the Treasure Valley, Magic Valley, Eastern Idaho and North Idaho. While growth is vital to our success, we remain focused on our mission, "Helping members achieve financial success."</h4>
      <MessageFromModalButton 
        messagePerson="Brenda Worrel"
        personTitle="CEO of Idaho Central Credit Union"
        partnerUrl="https://www.iccu.com"
        partner="Idaho Central Credit Union"
        message="It is an honor to be part of the USS IDAHO mission. As an Idaho based company founded in 1940, we are committed to supporting initiatives that are important to our state, our members, and our team members. We appreciate the sacrifices and dedication of our military members and families. On behalf of ICCU, thank you for your service!"
        personPhoto={data.brendaWorrel.childImageSharp.fluid}
        partnerLogo={<IdahoCentralLogo fillcolor='#1c8900' />}
      />
    </Col>
  </Row>
  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <AgriBeefLogo fillColor1="#ffffff" fillColor2="#ffffff"/>
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Agri Beef</h2>
      <h4>Real Families, Great People, Exceptional Beef</h4>
      <h4>We are real families and great people working hard every day to produce exceptional beef. Agri Beef is family-owned-and-operated company rooted in the Northwest and has been in business since 1968.</h4>
      <MessageFromModalButton 
        messagePerson="Rob Rebholtz"
        personTitle="President and CEO"
        partnerUrl="https://www.agribeef.com"
        partner="Agri Beef"
        message={<>"We extend our sincerest gratitude to the men and women who serve our great state and country in the U.S. Navy. Agri Beef is deeply honored to help perpetuate the bond between the citizens of the state of Idaho and the crews and families of the "gem of the fleet," the USS Idaho."</>}
        personPhoto={data.robRebholtz.childImageSharp.fluid}
        partnerLogo={<AgriBeefLogo fillColor1="#231f20" fillColor2="#7a2531" />}
      />
    </Col>
  </Row>
  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <AlbertsonsFamilyLogo />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>J.A. and Kathryn Albertson Family Foundation</h2>
      <h4>The J.A. and Kathryn Albertson Family Foundation is committed to accelerating opportunities in Idaho. We do this by investing time, energy, and resources into: Limitless Learning, Innovative Leaders, and Stronger Communities.</h4>
      <MessageFromModalButton 
        messagePerson="Roger Quarles"
        personTitle="Executive Director, J.A. and Kathryn Albertson Family Foundation"
        partnerUrl="https://jkaf.org"
        partner="J.A. and Kathryn Albertson Family Foundation"
        message="We are honored to support the USS Idaho Dolphin Scholarship Endowment Fund. Providing the resources for military family members to attain a quality education aligns with our values of learning, leadership, and strengthening community. We are also proud to make this gift in the name of Tom Wilford, former president of the J.A. &amp; Kathryn Albertson Family Foundation."
        personPhoto={data.rogerQuarles.childImageSharp.fluid}
        partnerLogo={<AlbertsonsFamilyLogo />}
      />
    </Col>
  </Row>
  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <BattelleLogo />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Battelle Energy Alliance</h2>
      <h4>Battelle Energy Alliance is responsible for the day-to-day management and operations of Idaho National Laboratory. INL is a U.S. Department of Energy national laboratory that performs work in each of DOE’s strategic goal areas: energy, national security, science and environment.  INL is the nation’s center for nuclear energy research and development.
</h4>
      <MessageFromModalButton 
        messagePerson="John C. Wagner"
        personTitle="Director of Idaho National Laboratory and President of Battelle Energy Alliance, LLC."
        partnerUrl="https://inl.gov/"
        partner="Battelle Energy Alliance, LLC."
        message={<>"Battelle Energy Alliance (BEA) is proud of the role Idaho National Laboratory (INL) has played in the development and modernization of the U.S. Nuclear Navy," said John Wagner, who serves as INL director and BEA president. "Support for our nation's armed forces and their families is in the lab's DNA and we are grateful for this opportunity to contribute to the USS Idaho Scholarship Fund."</>}
        personPhoto={data.johnCWagner.childImageSharp.fluid}
        partnerLogo={<BattelleLogo />}
      />
    </Col>
  </Row>
  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <HeclaMiningCompanyLogo fillColor1="#1e4184" fillColor2="#c7c3c2" />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Hecla Mining Company</h2>
      <h4>Hecla Mining Company is a precious metals company. Our business is to create value for our shareholders by discovering, acquiring, developing, producing, and marketing mineral resources at a profit. Our mission is to create long-term value for shareholders from mining silver, gold and associated base metals.</h4>
      <MessageFromModalButton 
        messagePerson="Phil Baker"
        personTitle="President and CEO of Hecla Mining Co"
        partnerUrl="https://www.hecla-mining.com/"
        partner="Hecla Mining Company"
        message={<>For 130 years, Hecla has supported Idaho families and our military. And we are now proud to support the brave men and women of our Navy who will serve on the USS Idaho. May the “Gem of the Fleet” be blessed with fair winds and following seas.</>}
        personPhoto={data.phillipsBaker.childImageSharp.fluid}
        partnerLogo={<HeclaMiningCompanyLogo fillColor1="#1e4184" fillColor2="#c7c3c2" />}
      />
    </Col>
  </Row>
  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <SELLogo fillColor="white" />
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Schweitzer Engineering Laboratories</h2>
      <h4>Making Electric Power Safer, More Reliable, and More Economical</h4>
      <MessageFormModalButtonSchweitzer 
        messagePerson="Edmund O. Schweitzer, III"
        messagePerson2="Dave Whitehead"
        personTitle="President and Chief Technology Officer"
        personTitle2="Chief Executive Officer"
        partnerUrl="https://selinc.com"
        partner="Schweitzer Engineering Laboratories"
        message={<>We are grateful and respectful for the men and women in uniform who protect our life, liberty and pursuit of happiness. We are honored to support the commissioning of the USS Idaho.</>}
        message2={<>It is SEL's honor to contribute to the USS Idaho and her crew’s distinguished mission. We are forever grateful for our U.S. Navy, and the USS Idaho sailors and their families.</>}
        personPhoto={data.edumundSchweitzer.childImageSharp.fluid}
        personPhoto2={data.daveWhitehead.childImageSharp.fluid}
        partnerLogo={<SELLogo fillColor="#003a5d"/>}
      />
    </Col>
  </Row>
    <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <DeltaDentalLogo fillColor="#4aa851" />
      {/* <DeltaDentalLogo fillColor="#fff" /> */}
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Delta Dental of Idaho</h2>
      <h4></h4>
      <MessageFromModalButton 
        messagePerson="Greg Donaca"
        personTitle="President and CEO"
        partnerUrl="https://www.deltadentalid.com/"
        partner="Delta Dental of Idaho"
        message={<>It’s Delta Dental of Idaho’s great honor to support the USS IDAHO and the men and women who serve to protect our country.</>}
        personPhoto={data.gregDonaca.childImageSharp.fluid}
        partnerLogo={<DeltaDentalLogo fillColor="#4aa851"/>}
      />
    </Col>
  </Row>

  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <a href="https://www.simplot.com/" target="_blank" rel="noopener noreferrer"><Img fluid={data.simplotLogoWhite.childImageSharp.fluid} alt="Simpot Company Foundation logo" /></a>
      {/* <SimplotLogo fillColor1="white" fillColor2="white" /> */}
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Simplot</h2>
      <h4>Bringing Earth's Resources to Life</h4>
      <MessageFromModalButton 
        messagePerson="Scott Simplot"
        personTitle="Chairman of the Board"
        partnerUrl="https://www.deltadentalid.com/"
        partner="Simplot"
        message={<>It is our highest honor to support the crew and family members of the USS Idaho for the sacrifices they make to keep our country safe. Go roam the seas, and come back to port safely. You are part of our family now.</>}
        personPhoto={data.scottSimplot.childImageSharp.fluid}
        partnerLogo={<SimplotLongLogo />}
        //partnerLogo={<SimplotLogo fillColor1="#dcb363" fillColor2="#73472e" />}
      />
    </Col>
  </Row>

  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <BoiseCascadeLogo fillColor="#3d9b46" fillColor2="#000000"/>
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Boise Cascade</h2>
      <h4>As a leading manufacturer and distributor of building materials, we bring people, products, and services together to build strong homes, businesses and communities that stand the test of time.</h4>
      <MessageFromModalButton 
        messagePerson="Nate Jorgensen"
        personTitle="Chief Executive Officer"
        partnerUrl="https://www.bc.com/"
        partner="Boise Cascade"
        message={<>We’re honored to be part of history in supporting the USS Idaho and its crews that will be protecting the Gem state and our country.</>}
        personPhoto={data.nateJorgensen.childImageSharp.fluid}
        partnerLogo={<BoiseCascadeLogo fillColor="#3d9b46" fillColor2="#000000"/>}
      />
    </Col>
  </Row>
  
  <Row className={`${style.supportersRow} my-4`}>
    <Col md={2} className="text-center logo-col">
      <IdahoForestGroupLogo fillColor="white" fillColor2="white"/>
      <p className="text-center mt-2" style={{fontSize: 'small', color: 'gray'}}>Click logo to visit partner website.</p>
    </Col>
    <Col md={10}>
      <h2>Idaho Forest Group</h2>
      <h4>As a leading manufacturer and distributor of building materials, we bring people, products, and services together to build strong homes, businesses and communities that stand the test of time.</h4>
      <MessageFromModalButton 
        messagePerson="Marc A. Brinkmeyer "
        personTitle="Owner"
        partnerUrl="https://www.bc.com/"
        partner="Idaho Forest Group"
        message={<>The Idaho Forest Group family is a proud supporter of the Armed Forces and we are excited to be able to support the USS Idaho, including its crew and their families. North Idaho has a rich naval history at Farragut State Park and a Naval Acoustic Research Detachment in Bayview. We want ensure that the culture and majesty of Idaho is apparent to all who see and serve aboard the submarine.</>}
        personPhoto={data.marcBrinkmeyer.childImageSharp.fluid}
        partnerLogo={<IdahoForestGroupLogo fillColor="#17468f" fillColor2="#087933"/>}
      />
    </Col>
  </Row> 
  <Row className={`${style.supportersRow} my-4`}>
            <Col md={2} className="text-center logo-col">
              <a
                href="https://idahopotato.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.potatoCommissionLogo.childImageSharp.fluid}
                  alt="Idaho Potato Commission"
                  style={{ width: "135px", height: "147px" }}
                />
              </a>
            </Col>
            <Col md={10}>
              <h2 >Idaho Potato Commission</h2>
              <MessageFromModalButton
                messagePerson="Jamey Higham"
                personTitle="CEO, Idaho Potato Commission"
                partnerUrl="https://idahopotato.com"
                partner="Idaho Potato Commission"
                message="The Idaho Potato Commission is truly honored to be part of this historic occasion, celebrating the commissioning of the USS IDAHO SSN 799. We are grateful to be able to celebrate a ship that reflects and embodies Idaho’s commitment to excellence and innovation."
                personPhoto={data.higman.childImageSharp.fluid}
                partnerLogo={
                  <Img
                    fluid={data.potatoCommissionLogo.childImageSharp.fluid}
                    alt="Idaho Potato Commission"
                  />
                }
              />
            </Col>
      </Row>

      <Row className={`${style.supportersRow} my-4`}>
            <Col md={2} className="text-center logo-col">
              <a
                href="https://www.l3harris.com/about-us"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.L3HarrisLogo.childImageSharp.fluid}
                  alt="L3Harris Logo"
                  style={{ width: "142px", height: "44px" }}
                />
              </a>
            </Col>
            <Col md={10}>
              <h2>L3Harris</h2>
              <h4>L3Harris is the Trusted Disruptor in defense tech. With customers’ mission-critical needs always in mind, our employees deliver end-to-end technology solutions connecting the space, air, land, sea, and cyber domains in the interest of national security.</h4>
              <MessageFromModalButton
                messagePerson="Nino DiCosmo"
                personTitle="President of Maritime Systems"
                partnerUrl="https://www.l3harris.com/about-us"
                partner="L3Harris"
                message="To the officers and crew of the USS IDAHO, and to the families who stand steadfast behind them: It is our profound privilege to be part of your journey. The technology we provide is built with two things in mind — overwhelming mission success every time, and your safe return home from every mission. As you take this magnificent vessel to the depths and across the horizons, know that L3Harris stands with you, today and always. Fair winds and following seas."
                personPhoto={data.ninoDiCosmo.childImageSharp.fluid}
                partnerLogo={
                  <Img
                    fluid={data.L3HarrisLogoAlt.childImageSharp.fluid}
                    alt="L3Harris Logo"
                    style={{ width: "172px", height: "44px" }}
                  />
                }
              />
            </Col>
      </Row>

      <Row className={`${style.supportersRow} my-4`}>
            <Col md={2} className="text-center logo-col">
              <a
                href="https://www.intgas.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.intermountainGasLogo.childImageSharp.fluid}
                  alt="L3Harris Logo"
                  style={{ width: "142px", height: "58px" }}
                />
              </a>
            </Col>
            <Col md={10}>
              <h2>Intermountain Gas</h2>
              <h4>Intermountain Gas Co. delivers energy to more than 441,000 customers in 74 communities across Idaho. Serving residential, commercial and industrial customers, the company is
committed to delivering safe, reliable and affordable energy services. With a legacy spanning over 75 years, Intermountain Gas remains focused on serving our communities and energizing lives for a better tomorrow.</h4>
              <MessageFromModalButton
                messagePerson="Hart Gilchrist"
                personTitle="VP of Business Development and External Affairs"
                partnerUrl="https://www.intgas.com/"
                partner="Intermountain Gas"
                message="Intermountain Gas is honored to support the USS Idaho and the men and women who will serve aboard her. This ship represents strength, service and the enduring connection between
Idaho and our nation’s defense. Being able to stand behind the USS Idaho is a point of immense pride for our company and our employees, and we are grateful for the opportunity to support those who dedicate their lives to protecting our freedoms."
                personPhoto={data.hartGilchrist.childImageSharp.fluid}
                partnerLogo={
                  <Img
                    fluid={data.intermountainGasLogo.childImageSharp.fluid}
                    alt="L3Harris Logo"
                    style={{ width: "172px", height: "68px" }}
                  />
                }
              />
            </Col>
      </Row>

  <GoldLevel />
  <SilverLevel />
  <BronzeLevel />
  
  {/* <CopperLevel />
  <BrassLevel /> */}
    </div>
  )
}

export default PlatinumLevel
